import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { v4 as uuidv4 } from "uuid";
import { Table, TableModule } from "primeng/table";
import * as FileSaver from "file-saver";
import { QuotesLine } from "../../../../core/models/qoutes/quoteLine";
import { QuotesLineAddressDto } from "../../../../core/models/qoutes/quotesLineAddressDto";
import { QuotesLinePortalKeyDto } from "../../../../core/models/qoutes/quotesLinePortalKeyDto";
import { UpdateTrackableOnQuotesOrderLinesRequestDto } from "../../../../core/models/qoutes/updateTrackableOnQuotesOrderLinesRequestDto";
import { LoaderService } from "../../../../core/services/loader.service";
import { OrderLineItemService } from "../../../../core/services/order-line-item.service";
import { CopyLinesComponent } from "../../../orders/components/copy-lines/copy-lines.component";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { SelectModule } from "primeng/select";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { DialogModule } from "primeng/dialog";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ConfirmDialogComponent } from "../../../../shared/components/confirm-dialog/confirm-dialog.component";
import { CreateHeaderQuoteService } from "../../../../core/services/create-header-quote.service";
import { CopyLinesQuotesDto } from "../../../../core/models/qoutes/copyLinesQuotesDto";
import { ExchangeRatesDto } from "../../../../core/models/shared/exchangeRateDto";
import { UpdateQuotesLineDto } from "../../../../core/models/qoutes/updateQuotesLineDto";
import { QuoteLinesDto } from "../../../../core/models/qoutes/quoteLinesDto";
import { CreateLineQuoteComponent } from "../create-line-quote/create-line-quote.component";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { ReleasedProduct } from "../../../../core/models/shared/releaseProduct";
import { ButtonModule } from "primeng/button";
import { TooltipModule } from "primeng/tooltip";

@UntilDestroy()
@Component({
  selector: "jni-quote-summary-line-items",
  templateUrl: "./quote-summary-line-items.component.html",
  styleUrls: ["./quote-summary-line-items.component.scss"],
  imports: [
    TableModule,
    SelectModule,
    FormsModule,
    CommonModule,
    ModalStackerComponent,
    DialogModule,
    ConfirmDialogModule,
    CopyLinesComponent,
    ConfirmDialogComponent,
    CreateLineQuoteComponent,
    ToggleSwitchModule,
    ButtonModule,
    TooltipModule,
  ],
})
export class QuoteSummaryLineItemsComponent {
  @Input() salesOrderLine: QuotesLineAddressDto[] = [];
  @Input() OrderLineId = "";
  @Input() currencyConversion!: ExchangeRatesDto;
  @Input() foreignCurrency!: string;
  @Input() releasedProductsList: ReleasedProduct[] = [];
  @Output() changeDetect = new EventEmitter<boolean>();
  @Output() gridRefresh = new EventEmitter<boolean>();
  @Input() quoteModalStatus = false;
  @Output() scrollHiddenStatus = new EventEmitter();

  showSmallLoader = false;
  isoCurrencyCode = "";
  netReteAfterConversion = 0;
  netConvertToUsd = "";
  netTotalPrice = "";
  netTotalPriceConverted = "";

  sellReteAfterConversion = 0;
  sellConvertToUsd = "";
  sellTotalPrice = "";
  sellTotalPriceConverted = "";
  //product: any;
  percentageSign = "%";
  selectedSaleOrderLine: QuotesLineAddressDto[] = [];
  quoteLineDisplayModal = false;
  orderLineNumber = 0;

  popUpMessage = "Are you sure you want to delete the selected lines?";
  dialogStatus = false;
  showWarningTrackleAllDialog = false;
  isTrackableAllChecked = false;
  salesOrderLineTrackable: QuotesLineAddressDto[] = [];

  @ViewChild("copyline", { static: false })
  copyline!: CopyLinesComponent;
  @ViewChild("dt") table!: Table;

  constructor(
    private _router: Router,
    private _orderLineItem: OrderLineItemService,
    private _toastr: JniToastrService,
    private _loaderService: LoaderService,
    //private config: NgbPopoverConfig,
    private _createHeaderQuoteService: CreateHeaderQuoteService
  ) {
    // this.config.placement = 'end';
    // this.config.triggers = 'hover';
  }

  redirectToLineItem() {
    if (this.OrderLineId) {
      this._router.navigate(["/proposal/add-line/" + this.OrderLineId]);
    }
  }

  onRedirectToLinePage(lineNumber: number, id: number) {
    if (this.OrderLineId) {
      if (this.quoteModalStatus) {
        this.orderLineNumber = id;
        this.quoteLineDisplayModal = true;
      } else {
        this.quoteLineDisplayModal = false;
        this._router.navigate([
          "/proposal/add-line/" + this.OrderLineId + "/" + id,
        ]);
      }
    }
  }

  closeModal() {
    this.quoteLineDisplayModal = false;
    this.gridRefresh.emit();
  }

  addScollHiddenClass() {
    this.scrollHiddenStatus.emit();
  }

  refreshGrid() {
    this.gridRefresh.emit();
  }

  onRowEditSave(salesOrderLine: QuotesLine) {
    this._loaderService.setLoaderState(true);
    if (
      !salesOrderLine.orderedPurchaseQuantityD365 ||
      salesOrderLine.orderedPurchaseQuantityD365 === 0 //||
      //salesOrderLine.orderedPurchaseQuantityD365 === '0'
    ) {
      this._loaderService.setLoaderState(false);
      this._toastr.error("Error", "Quantity is required");
      return;
    }

    if (!salesOrderLine.itemNumberD365) {
      this._loaderService.setLoaderState(false);
      this._toastr.error("Error", "Category is required");
      return;
    }

    if (!salesOrderLine.id) {
      salesOrderLine.salesOrderIdD365 = this.OrderLineId;
    } else {
      salesOrderLine.salesOrderIdD365 = this.OrderLineId;
      const lineObject = this.patchValueInLineObject(salesOrderLine);
      const saleOrderLineRequest = {
        id: salesOrderLine.id,
        lines: lineObject,
      } as unknown as UpdateQuotesLineDto;
      this._createHeaderQuoteService
        .updateQuoteLine(saleOrderLineRequest)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.changeDetect.emit(true);
            this._loaderService.setLoaderState(false);
            this.cancelAllEditRow();
            if (res.data) {
              this._toastr.success(
                "Success",
                res.message || "line item update successfully"
              );
            } else {
              this._toastr.error(
                "Error",
                res.message || "Error updating line item"
              );
            }
          },
          error: res => {
            this.changeDetect.emit(true);
            this._loaderService.setLoaderState(false);
            this._toastr.error(
              "Error",
              res.message || "Error updating line item"
            );
          },
        });
    }
  }

  patchValueInLineObject(saleOrderLineObject: QuotesLine) {
    const lineObject = {
      itemNumberD365: saleOrderLineObject?.itemNumberD365,
      externalItemNumberD365: saleOrderLineObject?.externalItemNumberD365,
      orderedPurchaseQuantityD365: parseFloat(
        saleOrderLineObject?.orderedPurchaseQuantityD365?.toString() ?? ""
      ),
      isnetInForeignCurrencyStatus:
        saleOrderLineObject?.isnetInForeignCurrencyStatus,
      purchasePriceD365: saleOrderLineObject?.purchasePriceD365 ?? 0,
      netTotalD365: saleOrderLineObject?.netTotalD365 ?? 0,
      netConversion: saleOrderLineObject?.netConversion?.toString(),
      netConversionTotal:
        saleOrderLineObject?.netConversionTotalD365?.toString(),
      sell: saleOrderLineObject?.sellD365 ?? 0,
      sellTotal: saleOrderLineObject?.sellTotalD365?.toString(),
      sellConversion: saleOrderLineObject?.sellConversion?.toString(),
      sellConversionTotal: saleOrderLineObject?.sellConversionTotal?.toString(),
      commission: saleOrderLineObject?.commissionD365 ?? 0,
      grossProfit: saleOrderLineObject?.grossProfitD365 ?? 0,
      lineDescriptionD365: saleOrderLineObject?.lineDescriptionD365,
      factoryNotes: saleOrderLineObject?.factoryNotesD365,
      currencyCodeD365: saleOrderLineObject?.currencyCodeD365,
      rates: saleOrderLineObject?.rates,
      locationD365: saleOrderLineObject?.locationD365,
      attentionInformationD365: saleOrderLineObject?.attentionInformationD365,
    } as unknown as QuoteLinesDto;
    return lineObject;
  }

  calculateSell(sellPrice: string, lineObject: QuotesLine) {
    this.showSmallLoader = true;
    const sellRate = sellPrice.toString().replace(/[^a-zA-Z0-9.]/g, "");
    if (sellRate) {
      if (this.currencyConversion) {
        if (this.currencyConversion.Rate != 0) {
          this.sellReteAfterConversion =
            parseFloat(sellRate) * this.currencyConversion?.Rate;
          if (this.sellReteAfterConversion.toString() != "") {
            this.sellConvertToUsd = this.sellReteAfterConversion.toString();
            lineObject.sellConversion = Number(this.sellConvertToUsd);
          }
        }
      }
      this.patchValueInTotalSell(
        sellRate,
        this.sellReteAfterConversion.toString(),
        lineObject.orderedPurchaseQuantityD365?.toString() ?? "",
        lineObject
      );
      this.calculateGrossProfit(lineObject);
    } else {
      lineObject.sellConversion = null;
      lineObject.sellTotalD365 = null;
      lineObject.sellConversionTotal = null;
      lineObject.grossProfitD365 = 0;
      lineObject.commissionD365 = 0;
    }
  }

  patchValueInTotalSell(
    sell: string,
    convertedSell: string,
    lineQuantity: string,
    lineObject: QuotesLine
  ) {
    const quantity = lineQuantity;
    if (quantity) {
      const sellPrice = parseFloat(sell) * parseInt(quantity);
      this.sellTotalPrice = sellPrice.toString();
      lineObject.sellTotalD365 = Number(this.sellTotalPrice);

      const sellPriceCon =
        parseFloat(
          convertedSell == "" || convertedSell == null ? "0" : convertedSell
        ) * parseInt(quantity);
      this.sellTotalPriceConverted = sellPriceCon.toString();
      lineObject.sellConversionTotal = Number(this.sellTotalPriceConverted);
    }
  }

  // onAddNewLine() {
  //   const object = {
  //     itemNumberD365: '',
  //     externalItemNumberD365: '',
  //     orderedPurchaseQuantityD365: '',
  //     purchasePriceD365: '',
  //     netTotalD365: '',
  //     netConversion: '',
  //     netConversionTotal: '',
  //     sell: '',
  //     sellTotal: '',
  //     sellConversion: '',
  //     sellConversionTotal: '',
  //     commission: '',
  //     grossProfit: '',
  //     status: '',
  //     lineDescriptionD365: '',
  //     factoryNotes: ''
  //   };
  //   this.salesOrderLine.push(object);
  // }

  onNetConversion(event: number, lineObject: QuotesLine) {
    const netRate = event.toString().replace(/[^a-zA-Z0-9.]/g, "");
    if (netRate) {
      const currency = lineObject.currencyCodeD365;
      this.isoCurrencyCode = currency ?? "";
      if (this.currencyConversion) {
        if (this.currencyConversion.Rate != 0) {
          this.netReteAfterConversion =
            parseFloat(netRate) * this.currencyConversion?.Rate;
          if (this.netReteAfterConversion.toString() != "") {
            this.netConvertToUsd = this.netReteAfterConversion.toString();
            lineObject.netConversion = Number(this.netConvertToUsd);
          }
        }
      }
      this.patchValueInTotalNet(
        netRate,
        this.netReteAfterConversion.toString(),
        lineObject.orderedPurchaseQuantityD365?.toString() ?? "",
        lineObject
      );
      this.calculateGrossProfit(lineObject);
    } else {
      lineObject.netConversion = 0;
      lineObject.netTotalD365 = 0;
      lineObject.netConversionTotalD365 = 0;
      lineObject.grossProfitD365 = 0;
      lineObject.commissionD365 = 0;
    }
  }

  grossProfit = 0;
  commission = 0;

  calculateGrossProfit(salesOrderLine: QuotesLine) {
    const netTotal = salesOrderLine.netTotalD365;
    const sellTotal = salesOrderLine.sellTotalD365;
    if (netTotal && sellTotal) {
      const grossProfit = ((sellTotal - netTotal) / sellTotal) * 100;
      const grossProfitRound = grossProfit.toFixed(2).toString();
      this.grossProfit = parseFloat(grossProfitRound);
      salesOrderLine.grossProfitD365 = this.grossProfit;
      const commission = (sellTotal - netTotal) * 0.5;
      const commissionRound = commission.toFixed(2).toString();
      this.commission = parseFloat(commissionRound);
      salesOrderLine.commissionD365 = this.commission;
    }
  }

  patchValueInTotalNet(
    net: string,
    convertedNet: string,
    lineQuantity: string,
    lineObject: QuotesLine
  ) {
    const quantity = lineQuantity;
    if (quantity) {
      const netprice = parseFloat(net) * parseInt(quantity);
      this.netTotalPrice = netprice.toString();
      lineObject.netTotalD365 = parseFloat(this.netTotalPrice);
      const netPriceCon =
        parseFloat(
          convertedNet == "" || convertedNet == null ? "0" : convertedNet
        ) * parseInt(quantity);
      this.netTotalPriceConverted = netPriceCon.toString();
      lineObject.netConversionTotalD365 = Number(this.netTotalPriceConverted);
    }
  }

  calculateQuantity(event: number, salesOrderLine: QuotesLine) {
    const quantity = event;
    if (quantity) {
      let netPrice = salesOrderLine.purchasePriceD365;
      if (netPrice) {
        netPrice = Number(netPrice.toString().replace(/[^a-zA-Z0-9.]/g, ""));
        const convertedNetPrice = salesOrderLine.netConversion;
        this.patchValueInTotalNet(
          netPrice.toString(),
          convertedNetPrice?.toString() ?? "",
          salesOrderLine.orderedPurchaseQuantityD365?.toString() ?? "",
          salesOrderLine
        );
      }
      let sellPrice = salesOrderLine.sellD365;
      if (sellPrice) {
        sellPrice = Number(sellPrice.toString().replace(/[^a-zA-Z0-9.]/g, ""));
        const convertedSellPrice = salesOrderLine.sellConversion;
        this.patchValueInTotalSell(
          sellPrice.toString(),
          convertedSellPrice?.toString() ?? "",
          salesOrderLine.orderedPurchaseQuantityD365?.toString() ?? "",
          salesOrderLine
        );
      }
      this.calculateGrossProfit(salesOrderLine);
    }
  }

  confirmDialogStatusData(status: boolean) {
    this.dialogStatus = false;
    if (status) {
      this.deleteLineItems();
    }
  }

  onDeleteButton() {
    if (this.selectedSaleOrderLine.length > 0) {
      this.dialogStatus = true;
    }
  }

  confirmAllLines() {
    this._loaderService.setLoaderState(true);
    this._orderLineItem
      .saveAndConfirmAllSaleOrderLines(this.OrderLineId)
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this._toastr.success(
              "Success",
              res.message || "All Order Lines Confirmed"
            );
            this.changeDetect.emit(true);
          } else {
            this._toastr.error(
              "Error",
              res.message || "Error Confirming Order Line Items"
            );
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error(
            "Error",
            res.message || "Error Confirming Order Line Items"
          );
        },
      });
  }

  displayModal = false;
  closable = false;

  showModalDialog() {
    if (this.selectedSaleOrderLine && this.selectedSaleOrderLine?.length > 0) {
      this.copyLineItems();
    } else {
      this.displayModal = true;
      this.copyline.getAllSalesOrderHeader();
      this.copyline.getAllQuoteHeader();
    }
  }

  closeModalDialog() {
    this.displayModal = false;
  }

  copyLineItems() {
    this._loaderService.setLoaderState(true);
    const linesArray: QuotesLinePortalKeyDto[] = [];

    this.selectedSaleOrderLine.forEach(x => {
      const soLine = x.salesOrderLine;
      if (soLine) {
        const line: QuotesLinePortalKeyDto = {
          ...soLine,
          oldPortalKey: x.salesOrderLine?.portalKeyD365 ?? "",
          portalKeyD365: uuidv4(),
          lineCopiedFrom: x.lineFrom,
        };
        linesArray.push(line);
      }
    });

    const copyLineArray: CopyLinesQuotesDto = {
      quotesLinePortalKeyDtos: linesArray,
      quotesId: this.OrderLineId,
    };
    this.selectedSaleOrderLine = [];

    this._createHeaderQuoteService
      .addLineData(copyLineArray)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this.changeDetect.emit(true);
            this._toastr.success("Success", res.message);
          } else {
            this._toastr.error(
              "Error",
              res.message || "Error adding line item"
            );
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "Error adding line item");
        },
      });
  }

  getNetGpPercentage(netTotal: number, sellTotal: number) {
    const serviceFee = 0.025 * sellTotal;
    const netGp = sellTotal - netTotal - serviceFee;
    const netGpPercentage = (netGp / sellTotal) * 100;
    if (Number.isFinite(netGpPercentage)) {
      return netGpPercentage;
    } else {
      return 0;
    }
  }

  editLine(id: number) {
    this.cancelAllEditRow();
    const row = this.table.value.filter(x => x.salesOrderLine.id === id);
    if (row.length > 0) {
      this.table.initRowEdit(row[0]);
    }
  }

  cancelAllEditRow() {
    this.table.value.forEach(x => {
      this.table.cancelRowEdit(x);
    });
  }

  deleteLineItems() {
    if (this.selectedSaleOrderLine?.length) {
      this._loaderService.setLoaderState(true);

      const deleteArray: number[] = [];
      this.selectedSaleOrderLine.forEach(x => {
        deleteArray.push(x.salesOrderLine?.id ?? 0);
      });

      this.selectedSaleOrderLine = [];
      this._createHeaderQuoteService
        .deleteLineItems(deleteArray)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            this.salesOrderLine = [];
            this.gridRefresh.emit();
            if (res.data) {
              this._toastr.success(
                "Success",
                res.message || "Record delete successfully"
              );
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error("Error", res.message || "Record not found");
          },
        });
    }
  }

  exportExcel() {
    if (this.selectedSaleOrderLine.length > 0) {
      this.exportExcelForFilterData(this.selectedSaleOrderLine);
      this.selectedSaleOrderLine = [];
    } else {
      this.exportExcelForFilterData(this.salesOrderLine);
    }
  }

  exportExcelForFilterData(filterclientlist: QuotesLineAddressDto[]) {
    const object = filterclientlist.map(datum => {
      return {
        ["Line Number"]: datum.salesOrderLine?.lineNumberD365,
        ["Trackable"]: datum.salesOrderLine?.isTrackable,
        ["Vendor Sku"]: datum.salesOrderLine?.externalItemNumberD365,
        ["Category"]: datum.salesOrderLine?.itemNumberD365,
        ["Description"]: datum.salesOrderLine?.lineDescriptionD365,
        ["Unmatched"]: datum.salesOrderLine?.orderedPurchaseQuantityD365,
        ["Quantity"]: datum.salesOrderLine?.orderedPurchaseQuantityD365,
        ["Sell"]: datum.salesOrderLine?.sellD365,
        ["Sell Total"]: datum.salesOrderLine?.sellTotalD365,
        ["Net"]: datum.salesOrderLine?.purchasePriceD365,
        ["Status"]: datum.salesOrderLine?.lineStatusD365,
        ["Vendor Name"]: datum.salesOrderLine?.vendorNameD365,
        ["PO Number"]: datum.salesOrderLine?.purchaseOrderD365,
        ["PO Assignment"]: datum.salesOrderLine?.vendorPoAssignmentD365,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "ProposalItemList");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  updateOrderLineTrackable(salesOrderLine: QuotesLine) {
    const objArray: UpdateTrackableOnQuotesOrderLinesRequestDto[] = [];
    const obj: UpdateTrackableOnQuotesOrderLinesRequestDto =
      {} as UpdateTrackableOnQuotesOrderLinesRequestDto;
    obj.lineId = salesOrderLine.id;
    obj.isTrackable = salesOrderLine.isTrackable ?? false;
    objArray.push(obj);
    this.saveTheQuotesLinesTrackable(objArray);
  }

  saveAllTrackable() {
    const objArray: UpdateTrackableOnQuotesOrderLinesRequestDto[] = [];
    this.salesOrderLineTrackable.forEach(x =>
      objArray.push({
        lineId: x.salesOrderLine?.id ?? 0,
        isTrackable: this.isTrackableAllChecked,
      })
    );
    this.saveTheQuotesLinesTrackable(objArray, true);
    this.showWarningTrackleAllDialog = false;
  }

  cancelTrackable() {
    this.showWarningTrackleAllDialog = false;
  }

  saveTheQuotesLinesTrackable(
    arrayList: UpdateTrackableOnQuotesOrderLinesRequestDto[],
    gridRefresh = false
  ) {
    this._loaderService.setLoaderState(true);
    this._createHeaderQuoteService
      .updateTrackableOnSalesOrderLines(arrayList)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          //if (res.data) {
          if (res?.status?.toLowerCase() === "success") {
            this._toastr.success(
              "Success",
              res.message || "Trackable save successfully"
            );
            if (gridRefresh) {
              this.gridRefresh.emit();
            }
          } else {
            this._toastr.error(
              "Error",
              res.message || "Error while updating trackable field"
            );
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error(
            "Error",
            res.message || "Error Updating Invoice Email"
          );
        },
      });
  }

  selectedUnselectAllTrackable(event: MouseEvent) {
    const target = event?.target as HTMLInputElement;
    if (target.checked) {
      this.isTrackableAllChecked = true;
    } else {
      this.isTrackableAllChecked = false;
    }

    this.salesOrderLineTrackable = this.salesOrderLine.filter(
      x =>
        x.salesOrderLine?.itemNumberD365?.toLowerCase() !== "set up" &&
        x.salesOrderLine?.itemNumberD365?.toLowerCase() !== "setup"
    );

    if (this.salesOrderLineTrackable?.length > 0) {
      this.showWarningTrackleAllDialog = true;
    }
  }
}
